module.exports = __webpack_public_path__ + "img/logo-icon-app.242bb9fa.png";